// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-slider {
  /* display: block; */
  width: 75vw;
  height: auto;
  text-align: center;
  /* display: grid; */
  grid-template-columns: 1fr;
}

.slider-title-quote {
  content: '"';
  color: turquoise;
  font-size: 46px;
  font-family: 'Times New Roman', Times, serif;
}

.slider-title {
  font-size: 30px;
  line-height: 6rem;
}

.testimonial-slider ul.slider {
  /* display: block; */
  list-style: none;
  padding: 0;
  /* position: relative; */
  /* display: inline-block; */
  width: 100%;
  /* height: 350px; */
  /* overflow: auto; */
  /* overflow: auto; */
  margin: 0 auto;
  display: grid;
}

.testimonial-slider ul.slider li {
  /* position: absolute; */
  /* display: block; */
  grid-row-start: 1;
  grid-column-start: 1;
  width: 100%;
  opacity: 0;
  margin: 0 auto;
}

.testimonial-slider ul::before {
  grid-row-start: 1;
  grid-column-start: 1;
  font-family: 'Montserrat';
  font-weight: 800;
  content: '”';
  font-size: 200px;
  color: turquoise;
}

.testimonial-slider ul.slider li:nth-child(1) {
  animation: fade-animation-1 20s infinite;
}
.testimonial-slider ul.slider li:nth-child(2) {
  animation: fade-animation-2 20s infinite;
}
.testimonial-slider ul.slider li:nth-child(3) {
  animation: fade-animation-3 20s infinite;
}

.testimonial-slider q {
  /* display: inline-block; */
  font-weight: 400;
  font-size: 1.5rem;
  letter-spacing: 0.5pt;
  text-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  line-height: 2rem;
}

.testimonial-slider .source {
  margin-top: 25px;
  color: turquoise;
  font: italic 400 30px / 1.35 'Raleway', Helvetica, Arial, Verdana, sans-serif;
}

/* KEYFRAME DECLARATIONS */
@keyframes fade-animation-1 {
  0%,
  33% {
    opacity: 1;
  }
  34%,
  66% {
    opacity: 0;
  }
  67%,
  100% {
    opacity: 0;
  }
}
@keyframes fade-animation-2 {
  0%,
  33% {
    opacity: 0;
  }
  34%,
  66% {
    opacity: 1;
  }
  67%,
  100% {
    opacity: 0;
  }
}
@keyframes fade-animation-3 {
  0%,
  33% {
    opacity: 0;
  }
  34%,
  66% {
    opacity: 0;
  }
  67%,
  100% {
    opacity: 1;
  }
}
/* @keyframes fade-animation-4 {
     0%, 75%, 100% {
         opacity:0
     }
     78%, 97% {
         opacity: 1;
     }
 } */
/*
 @-webkit-keyframes fade-animation-4 {
     0%, 75%, 100% {
         opacity:0
     }
     78%, 97% {
         opacity: 1;
     }
 } */

 @media (max-width: 415px) {
  .testimonial-slider {
    /* display: block; */
    width: 90vw;
    height: auto;
    text-align: center;
    /* display: grid; */
    grid-template-columns: 1fr;
  }

  .slider-title {
    font-size: 24px;
    line-height: 6rem;
    font-weight: 600;
  }

  .testimonial-slider-content q{
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/Slider.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,UAAU;EACV,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAEE,wCAAwC;AAC1C;AACA;EAEE,wCAAwC;AAC1C;AACA;EAEE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA,0BAA0B;AAC1B;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;AACA;EACE;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;AACF;AACA;;;;;;;IAOI;AA4CJ;;;;;;;;IAQI;;CAEH;EACC;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".testimonial-slider {\n  /* display: block; */\n  width: 75vw;\n  height: auto;\n  text-align: center;\n  /* display: grid; */\n  grid-template-columns: 1fr;\n}\n\n.slider-title-quote {\n  content: '\"';\n  color: turquoise;\n  font-size: 46px;\n  font-family: 'Times New Roman', Times, serif;\n}\n\n.slider-title {\n  font-size: 30px;\n  line-height: 6rem;\n}\n\n.testimonial-slider ul.slider {\n  /* display: block; */\n  list-style: none;\n  padding: 0;\n  /* position: relative; */\n  /* display: inline-block; */\n  width: 100%;\n  /* height: 350px; */\n  /* overflow: auto; */\n  /* overflow: auto; */\n  margin: 0 auto;\n  display: grid;\n}\n\n.testimonial-slider ul.slider li {\n  /* position: absolute; */\n  /* display: block; */\n  grid-row-start: 1;\n  grid-column-start: 1;\n  width: 100%;\n  opacity: 0;\n  margin: 0 auto;\n}\n\n.testimonial-slider ul::before {\n  grid-row-start: 1;\n  grid-column-start: 1;\n  font-family: 'Montserrat';\n  font-weight: 800;\n  content: '”';\n  font-size: 200px;\n  color: turquoise;\n}\n\n.testimonial-slider ul.slider li:nth-child(1) {\n  -webkit-animation: fade-animation-1 20s infinite;\n  animation: fade-animation-1 20s infinite;\n}\n.testimonial-slider ul.slider li:nth-child(2) {\n  -webkit-animation: fade-animation-2 20s infinite;\n  animation: fade-animation-2 20s infinite;\n}\n.testimonial-slider ul.slider li:nth-child(3) {\n  -webkit-animation: fade-animation-3 20s infinite;\n  animation: fade-animation-3 20s infinite;\n}\n\n.testimonial-slider q {\n  /* display: inline-block; */\n  font-weight: 400;\n  font-size: 1.5rem;\n  letter-spacing: 0.5pt;\n  text-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n  line-height: 2rem;\n}\n\n.testimonial-slider .source {\n  margin-top: 25px;\n  color: turquoise;\n  font: italic 400 30px / 1.35 'Raleway', Helvetica, Arial, Verdana, sans-serif;\n}\n\n/* KEYFRAME DECLARATIONS */\n@keyframes fade-animation-1 {\n  0%,\n  33% {\n    opacity: 1;\n  }\n  34%,\n  66% {\n    opacity: 0;\n  }\n  67%,\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fade-animation-2 {\n  0%,\n  33% {\n    opacity: 0;\n  }\n  34%,\n  66% {\n    opacity: 1;\n  }\n  67%,\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fade-animation-3 {\n  0%,\n  33% {\n    opacity: 0;\n  }\n  34%,\n  66% {\n    opacity: 0;\n  }\n  67%,\n  100% {\n    opacity: 1;\n  }\n}\n/* @keyframes fade-animation-4 {\n     0%, 75%, 100% {\n         opacity:0\n     }\n     78%, 97% {\n         opacity: 1;\n     }\n } */\n\n@-webkit-keyframes fade-animation-1 {\n  0%,\n  33% {\n    opacity: 1;\n  }\n  34%,\n  66% {\n    opacity: 0;\n  }\n  67%,\n  100% {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes fade-animation-2 {\n  0%,\n  33% {\n    opacity: 0;\n  }\n  34%,\n  66% {\n    opacity: 1;\n  }\n  67%,\n  100% {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes fade-animation-3 {\n  0%,\n  33% {\n    opacity: 0;\n  }\n  34%,\n  66% {\n    opacity: 0;\n  }\n  67%,\n  100% {\n    opacity: 1;\n  }\n}\n/*\n @-webkit-keyframes fade-animation-4 {\n     0%, 75%, 100% {\n         opacity:0\n     }\n     78%, 97% {\n         opacity: 1;\n     }\n } */\n\n @media (max-width: 415px) {\n  .testimonial-slider {\n    /* display: block; */\n    width: 90vw;\n    height: auto;\n    text-align: center;\n    /* display: grid; */\n    grid-template-columns: 1fr;\n  }\n\n  .slider-title {\n    font-size: 24px;\n    line-height: 6rem;\n    font-weight: 600;\n  }\n\n  .testimonial-slider-content q{\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
